import { css } from 'styled-components';

// internal
import colors from '@app/assets/styles/colors';

export const InputShadow = () => {
  return css`
    box-shadow: 2px 2px 5px 2px #dcdcdc;
  `;
};

export const Input = (border: boolean) => {
  return css`
    ${border && 'border: none !important;'}
    font-size: 16px;
    padding: 4px 8px !important;
  `;
};

export const InputError = () => {
  return css`
    border: 1px solid ${colors.error} !important;
  `;
};
